import React from 'react';

import {
  MembershipNameTextDisplay,
  MembershipTextDisplay,
} from '@components/admin/members/MembershipFormDetails/Forms';
import { SpinnerModal } from '@components/SpinnerModal';
import { staffStrings } from '@data/staff';
import { useResendEmail } from '@hooks/mutation/dashboard/useResendEmail';
import { useCountDown } from '@hooks/useCountDown';
import Collapse from '@material-ui/core/Collapse';
import { MembershipFormFields, PrincipalForm } from '@models/MembershipForm';
import { makeMuiStyles, useCommonStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  formContainer: {
    ...common.flexColumn,
    marginBottom: '1rem',
  },
}));

export const PrincipalDisplay: React.FC<{
  values: PrincipalForm;
  expand?: boolean;
  emailVerified?: boolean;
}> = ({ values, expand = true, emailVerified = true }) => {
  const classes = { ...useStyles(), ...useCommonStyles() };
  const resendEmail = useResendEmail();
  const countdown = useCountDown(60);

  return (
    <div className={classes.formContainer}>
      <SpinnerModal open={resendEmail.isLoading} />
      <Collapse in={expand} timeout="auto" unmountOnExit>
        <MembershipNameTextDisplay
          lastNameField={MembershipFormFields.shared.principalLastName}
          lastName={values.principalLastName}
          firstNameField={MembershipFormFields.shared.principalFirstName}
          firstName={values.principalFirstName}
        />
        <MembershipTextDisplay
          field={MembershipFormFields.shared.principalCellphone}
          value={values.principalCellphone}
        />
        <MembershipTextDisplay
          field={MembershipFormFields.shared.principalLandline}
          value={values.principalLandline}
        />
        <MembershipTextDisplay
          field={MembershipFormFields.shared.principalEmail}
          value={
            <span className={classes.whitespacePre}>
              {values.principalEmail}
              {emailVerified ? null : (
                <>
                  （{staffStrings.emailNotVerified}）
                  {countdown.isCounting ? (
                    <span className={clsx(classes.textGray500, classes.underline)}>
                      {staffStrings.resendEmail}({countdown.timeLeft}s)
                    </span>
                  ) : (
                    <a
                      className={clsx(classes.link, classes.underline)}
                      onClick={() => {
                        resendEmail
                          .mutateAsync({ email: values.principalEmail })
                          .then(() => countdown.start());
                      }}
                    >
                      {staffStrings.resendEmail}
                    </a>
                  )}
                </>
              )}
            </span>
          }
        />
      </Collapse>
    </div>
  );
};
